import { downloadBffFile } from "../../../common/download/downloadBffFile";
import { sanitizeFilename } from "../../../common/utils/sanitizeUtils";

export const downloadProcurementSummary = ({ projectId, fileName }: { projectId: string; fileName: string }) =>
  downloadBffFile(`/api/projects/${projectId}/procurement-summary/pdf`, sanitizeFilename(`${fileName}.pdf`));
